// Global packages and components
import { useState, useEffect } from 'react'
import { LinkInner } from '~/components'
import { getCustomFilterLabel } from '~/utils'

// Types
import type { QueryBodyAttribute, NavItem, FilterLabel } from '~/types'

interface NavLinkProps extends NavItem {
  className?: string
  hasArrow?: boolean
  activeAttributes?: QueryBodyAttribute[]
  name: string
  filterLabels?: FilterLabel[]
  onClick: () => void
}

// Main export
const FilterLink = ({
  icon,
  title,
  titleBold,
  titleHighlight,
  className,
  hasArrow,
  activeAttributes,
  name,
  filterLabels,
  onClick,
}: NavLinkProps) => {
  const [activeValues, setActiveValues] = useState<string[]>([])

  useEffect(() => {
    const filter = activeAttributes?.length
      ? activeAttributes.find(e => e.key == name)
      : null

    if (filter) {
      setActiveValues(filter.values)
    } else {
      setActiveValues([])
    }
  }, [name, activeAttributes])

  return (
    <button
      onClick={onClick}
      className={'text-left ' + className}
    >
      <LinkInner
        icon={icon}
        title={title}
        titleBold={titleBold}
        titleHighlight={titleHighlight}
        hasArrow={hasArrow}
      />
      {activeValues && (
        <p className="mb-0 pt-1 text-left text-sm font-semibold text-teal-green">
          {activeValues
            .map(value => {
              const customLabel = getCustomFilterLabel(
                name,
                value,
                filterLabels
              )

              return customLabel ?? value
            })
            .join(', ')}
        </p>
      )}
    </button>
  )
}

export default FilterLink
